import React from 'react'
import { Slice } from 'gatsby'
import { SliceZone } from '@prismicio/react'

const components = {
  accordion: ({ slice }) => <Slice alias='accordion' slice={slice} />,
  auction: ({ context, slice }) => <Slice alias='auction' slice={slice} context={context} />,
  auction_calendar: ({ slice }) => <Slice alias='auctionCalendar' slice={slice} />,
  banner_with_caption: ({ slice }) => <Slice alias='bannerWithCaption' slice={slice} />,
  banner_with_quote: ({ slice }) => <Slice alias='bannerWithQuote' slice={slice} />,
  card_deck: ({ context, slice }) => <Slice alias='cardDeck' slice={slice} uid={context.uid} />,
  case_studies: ({ slice }) => <Slice alias='caseStudies' slice={slice} />,
  company_cards: ({ slice }) => <Slice alias='companyCards' slice={slice} />,
  contact: ({ context, slice }) => <Slice alias='contact' slice={slice} treatyItem={context.treatyItem} wantedItem={context.wantedItem} />,
  counter: ({ slice }) => <Slice alias='counter' slice={slice} />,
  headshots: ({ slice }) => <Slice alias='headshots' slice={slice} />,
  hero: ({ context, slice }) => {
    return (context.navState === 'auction' || !context.navState) && <Slice alias='hero' slice={slice} />
  },
  icon_banner: ({ slice }) => <Slice alias='iconBanner' slice={slice} />,
  icon_cards: ({ slice }) => <Slice alias='iconCards' slice={slice} />,
  image_gallery: ({ slice }) => <Slice alias='image' slice={slice} />,
  inventory: ({ slice }) => <Slice alias='inventory' slice={slice} />,
  map: ({ slice }) => <Slice alias='map' slice={slice} />,
  quote: ({ slice }) => <Slice alias='quote' slice={slice} />,
  selling: ({ slice }) => <Slice alias='selling' slice={slice} />,
  steps: ({ slice }) => <Slice alias='steps' slice={slice} />,
  specifications: ({ slice }) => <Slice alias='specifications' slice={slice} />,
  text: ({ slice }) => <Slice alias='text' slice={slice} />,
  video: ({ slice }) => <Slice alias='video' slice={slice} />,
  virtual_tour: ({ slice }) => <Slice alias='virtualTour' slice={slice} />
}

const SliceList = ({ navState, treatyItem, slices, showSlices, wantedItem, uid }) => {
  return (
    <SliceZone
      slices={slices}
      context={{
        navState,
        showSlices,
        treatyItem,
        wantedItem,
        uid
      }}
      components={components}
      defaultComponent={() => null}
    />
  )
}

export default SliceList
